import { useState } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  text: string;
}

const MapNotification = ({ text }: IProps): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(true);

  return (
    <div className="map-notification__container">
      <div className={`map-notification animate__animated animate__faster ${visible ? 'animate__fadeInDown' : 'animate__fadeOutUp'}`}>
        <p className="family-regular text-size-">{text}</p>
        <Icon name={Icons.Close} onPress={() => setVisible(false)} className="color-gray2 cursor-pointer" size={10} />
      </div>
    </div>
  );
};

export default MapNotification;
